<template>
  <div class="animated fadeIn">
    <div>
      <b-row v-if="loading">
        <b-col md="6">
          <atom-spinner
            :animation-duration="1000"
            :size="60"
            color="#ff1d5e"
            class="float-right my-4"
          />
        </b-col>
      </b-row>
    </div>
    <div v-if="!loading">
      <b-row
        ><b-col md="9"><h3>Commission Report</h3></b-col></b-row
      >
      <b-row>
        <b-col md="6">
          <b-row>
            <b-col><h4>Commission Dashboard</h4></b-col>
            <b-col md="5">
              <eb-select
                style="background-color: #fff"
                id="text"
                type="text"
                label="text"
                :options="dayOptions"
                v-model="selectedDate"
                :selected="selectedDate.text"
                @input="changeDateFilter"
              >
              </eb-select>
              <c-date
                ref="compRef"
                modalRef="modalRef"
                modalId="dateModal"
                @customDateRange="findCustomDate"
              ></c-date>
            </b-col>
          </b-row>
          <b-row
            ><b-col>
              <b-card-group deck>
                <b-card class="orderbyStatus-header">
                  <template #header>
                    <div class="row d-flex justify-content-between">
                      <h4 class="text-white col-md-6">Total Commission Value</h4>
                      <h4 class="text-white col-md-6 pt-0 pb-0">
                        रु {{ totalCommission }}
                      </h4>
                    </div>
                  </template>
                  <div class="row">
                    <h4 class="col-md-6 pt-0 pb-0">Total Order Value</h4>
                    <h4 class="col-md-6 pt-0 pb-0">रु {{ orderValue }}</h4>
                  </div>
                  <div class="row">
                    <h4 class="col-md-6 pt-0 pb-0">No of Order</h4>
                    <h4 class="col-md-6 pt-0 pb-0">{{ orderCount }}</h4>
                  </div>
                </b-card>
              </b-card-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="9"><h4>Collected Commision VS Order Value</h4></b-col>
        <b-col md="3">
          <eb-select
            style="background-color: #fff"
            id="text"
            type="text"
            label="text"
            :options="dayOptions"
            v-model="selectedDate1"
            :selected="selectedDate1.text"
            @input="changeDateFilter1"
          >
          </eb-select>
          <c-date
            ref="compRef1"
            modalRef="modalRef1"
            modalId="dateModal1"
            @customDateRange="findCustomDate1"
          ></c-date>
        </b-col>
      </b-row>
      <b-row class="mb-3">
        <b-col>
          <b-card>
            <BarChart :chart-data="chartData" :chart-options="barChartOptions" />
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6"><h4>Seller Wise Commission Report</h4></b-col>
        <b-col md="3">
          <eb-select
            style="background-color: #fff"
            id="text"
            type="text"
            label="text"
            :options="sellerList"
            v-model="selectedSeller"
            :selected="selectedSeller.text"
            placeholder="Select Seller"
            @input="fetchSellerWiseCommission"
          >
          </eb-select>
        </b-col>
        <b-col md="3">
          <eb-select
            style="background-color: #fff"
            id="text"
            type="text"
            label="text"
            :options="dayOptions"
            v-model="selectedDate2"
            :selected="selectedDate2.text"
            @input="changeDateFilter2"
          >
          </eb-select>
          <c-date
            ref="compRef2"
            modalRef="modalRef2"
            modalId="dateModal2"
            @customDateRange="findCustomDate2"
          ></c-date>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <b-table
              hover="hover"
              :striped="false"
              bordered="bordered"
              small="small"
              fixed="fixed"
              responsive="sm"
              :items="tableData"
              :fields="fields"
              thead-class="header"
              :current-page="currentPage"
              :per-page="perPage"
              :filter="filter"
              @filtered="onFilter"
              show-empty
              :busy="loading"
            >
              <template slot="cell(action)" slot-scope="data">
                <b-button variant="primary" @click="viewDetails(data.item)"
                  >View Detail
                </b-button>
              </template>
            </b-table>
            <div style="float: right">
              <b-pagination
                v-model="currentPage"
                :per-page="perPage"
                :total-rows="filterCount"
                aria-controls="my-table"
                prev-text="Prev"
                next-text="Next"
                hide-goto-end-buttons
              ></b-pagination></div
          ></b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import ebSelect from "@/components/FormElements/Select.vue";
import cDate from "@/components/FormElements/CustomDate.vue";
import BarChart from "@/components/chart/BarChart";
import moment from "moment/moment";
import { mapState } from "vuex";
import commissionVsOrderValueGraph from "@/utils/commissionVsOrderValueGraph";
import { AtomSpinner } from "epic-spinners";

export default {
  name: "Reports",
  components: {
    ebSelect,
    cDate,
    BarChart,
    AtomSpinner,
  },
  data() {
    return {
      loading: false,
      perPage: 10,
      currentPage: 1,
      filterCount: 0,
      filter: "",
      totalCommission: 0,
      orderCount: 0,
      orderValue: 0,
      cFromDate: "",
      cToDate: "",
      dayOptions: [
        {
          text: "Today",
          value: 0,
        },
        {
          text: "7 days",
          value: 6,
        },
        {
          text: "30 days",
          value: 29,
        },
        {
          text: "Custom",
          value: "Custom",
        },
      ],
      selectedDate: {
        text: "Today",
        value: 0,
      },
      selectedDate1: {
        text: "Today",
        value: 0,
      },
      selectedDate2: {
        text: "Today",
        value: 0,
      },
      selectedSeller: { text: "All Seller", value: "All Seller" },
      fields: [
        {
          key: "sellerName",
        },
        {
          key: "email",
        },
        {
          key: "month",
        },
        {
          key: "commission",
        },
        {
          key: "walletAmount",
        },
        {
          key: "totalOrderAmount",
        },
        {
          key: "action",
        },
      ],
      items: [],
      loading: false,
    };
  },
  computed: {
    ...mapState({
      commissionVsOrderGraph: (state) => state.partner.chartData,
      partnerList: (state) => state.partner.partnerList,
    }),
    userId() {
      if (this.$store.getters["auth/getUserID"]) {
        return this.$store.getters["auth/getUserID"];
      } else {
        return JSON.parse(sessionStorage.getItem("userLogin"))["_id"];
      }
    },
    sellerList() {
      let sellerList = [{ text: "All Seller", value: "All Seller" }];
      this.partnerList.forEach((el) => {
        if (el.category == "SELLER") {
          let obj = {
            text: el.authentication.userName,
            value: el._id,
          };
          sellerList.push(obj);
        }
      });
      return sellerList;
    },
    tableData() {
      let data = [];
      if (this.items?.length > 0) {
        this.items.forEach((item) => {
          let obj = {
            sellerName: item.name,
            email: item.email,
            month:
              `${moment()
                .month(item.month - 1)
                .format("MMM")}` +
              "-" +
              `${item.year.toString().slice(-2)}`,
            commission: Math.abs(Math.trunc(Number(item.commission))),
            walletAmount: Math.trunc(Number(item["wallet_amount"])),
            totalOrderAmount: Math.trunc(Number(item["order_amount"])),
          };
          data.push(obj);
        });
        return data;
      }
    },
    chartData() {
      const data = this.commissionVsOrderGraph;

      let orderArr = [];

      if (data["total-order-value-graph"]?.length) {
        data["total-order-value-graph"].forEach((el) => {
          let obj = {
            date: `${el.day}/${el.month}/${el.year}`,
            ordervalue: el["total_order_value"],
          };
          orderArr.push(obj);
        });
      }

      let commissionObj = {};
      if (data["total-collected-commission-graph"]?.length) {
        data["total-collected-commission-graph"].forEach((el) => {
          commissionObj[`${el.day}/${el.month}/${el.year}`] = {
            commissionValue: el.amount,
          };
        });
      }

      let arr = [];
      if (orderArr?.length) {
        orderArr.forEach((el) => {
          let obj = {
            ...el,
            commissionValue: commissionObj[el.date] ? commissionObj[el.date] : 0,
          };
          arr.push(obj);
        });
      }

      let commissionData = "";
      let orderValueData = "";
      if (this.$currentUserData.category == "TA") {
        commissionData = "commissionValue";
        orderValueData = "ordervalue";
      }
      return commissionVsOrderValueGraph(arr, commissionData, orderValueData);
    },
    barChartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            display: true,
            beginAtZero: true,
            grid: {
              display: false,
              drawBorder: false,
            },
            ticks: {
              callback: function (value) {
                const valueLegend = this.getLabelForValue(value);
                const valueLegendRep = valueLegend.replaceAll(",", "");
                if (Number(valueLegendRep) < 2) {
                  return valueLegendRep * 10;
                } else {
                  const valueShort = Number(valueLegendRep) / 1000;
                  return valueShort + " " + "k";
                }
              },
            },
          },
          x: {
            display: true,
            ticks: {
              display: true,
            },
            grid: {
              display: false,
              drawBorder: false,
            },
          },
        },
      };
    },
  },
  methods: {
    viewDetails(data) {
      // this.$router.push({ name: "Seller Commission" });
    },
    onFilter(list) {
      this.filterCount = list?.length;
      this.currentPage = 1;
    },
    changeDateFilter(e) {
      if (e.value === "Custom") {
        this.$refs["compRef"].openModal();
      } else {
        this.fetchTotalCommissionValue();
      }
    },
    changeDateFilter1(e) {
      if (e.value === "Custom") {
        this.$refs["compRef1"].openModal();
      } else {
        this.fetchCommissionVsOrderValue();
      }
    },
    changeDateFilter2(e) {
      if (e.value === "Custom") {
        this.$refs["compRef2"].openModal();
      } else {
        this.fetchSellerWiseCommission();
      }
    },
    calcDateData(val) {
      var data = {};
      if (val == "Custom") {
        data.fromDate = this.cFromDate;
        data.toDate = this.cToDate;
      } else {
        data.fromDate = moment().subtract(val, "days").format("YYYY-MM-DD");
        data.toDate = moment().format("YYYY-MM-DD");
      }
      return data;
    },
    async fetchTotalCommissionValue() {
      const data = [
        {
          key: "total-orders-value",
          variables: {
            ...this.calcDateData(this.selectedDate.value),
            tenant: this.userId,
          },
        },
        {
          key: "total-commission-value",
          variables: {
            ...this.calcDateData(this.selectedDate.value),
            tenant: this.userId,
          },
        },
      ];
      const fetchedData = await this.$store.dispatch("partner/fetchBulkAnalyticReport", {
        items: data,
      });
      try {
        this.totalCommission = Math.abs(
          Math.trunc(Number(fetchedData["total-commission-value"]["amount"] || 0))
        );
        this.orderCount = fetchedData["total-orders-value"]["no_of_orders"];
        this.orderValue = Math.trunc(
          Number(fetchedData["total-orders-value"]["total_order_value"])
        );
      } catch (error) {
        console.log(error);
      }
    },
    async fetchCommissionVsOrderValue() {
      const data = [
        {
          key: "total-collected-commission-graph",
          variables: {
            ...this.calcDateData(this.selectedDate1.value),
            tenant: this.userId,
          },
        },
        {
          key: "total-order-value-graph",
          variables: {
            ...this.calcDateData(this.selectedDate1.value),
            tenant: this.userId,
          },
        },
      ];
      await this.$store.dispatch("partner/fetchChart", {
        items: data,
      });
    },
    findCustomDate(val) {
      this.cFromDate = val.fromDate;
      this.cToDate = val.toDate;
      this.fetchTotalCommissionValue();
    },
    findCustomDate1(val) {
      this.cFromDate = val.fromDate;
      this.cToDate = val.toDate;
      this.fetchCommissionVsOrderValue();
    },
    findCustomDate2(val) {
      this.cFromDate = val.fromDate;
      this.cToDate = val.toDate;
      this.fetchSellerWiseCommission();
    },
    async fetchSellerWiseCommission() {
      let datakey = "tenant-commission-report";
      const data = [
        {
          key: "tenant-commission-report",
          variables: {
            ...this.calcDateData(this.selectedDate2.value),
            tenant: this.userId,
          },
        },
      ];
      if (this.selectedSeller.value !== "All Seller") {
        data[0].variables.userId = this.selectedSeller.value;
        data[0].key = "seller-wise-commission-report";
        datakey = "seller-wise-commission-report";
      }
      let fetchedData = await this.$store.dispatch("partner/fetchBulkAnalyticReport", {
        items: data,
      });

      this.items = fetchedData[datakey];
    },
  },
  async mounted() {
    await this.fetchTotalCommissionValue();
    await this.fetchCommissionVsOrderValue();
    await this.fetchSellerWiseCommission();
  },
};
</script>

<style scoped>
.orderbyStatus-header .card-header {
  background: #2c7df7;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
</style>
